import React, { Fragment, useEffect, useState } from "react";
import { Modal, Select, Dropdown, Menu } from 'antd';
import styles from "./scss/member.module.scss";
//import users from "../../styles/images/1a.png";
import { URButton } from "../../../shared/widgets/button";
import { URAvatarGroup } from "../../../shared/widgets/avatarGroup";
import { URStatusDot } from "../../../shared/widgets/avatarGroup/statusDot";
import { chatwindowDetails, contacts, contactwindowDetails, initialStateModel, LoginState } from "../../../models/model";
import { useSelector } from "react-redux";
import _ from "lodash";
import { toastInformation, userStatusColor } from "../../../base/callService/common";
import { SocketChatService } from "../../../base/socketChatService";
import { ChatService as Service } from "../../../base/chatService";
import { generateChatID, SearchAddMemberTeam, userInfo } from "../../../base/socketChatService/utils";
import { useHistory } from "react-router";
import { compareName } from "../../../base/utils";
import { chatSideWindow } from "../../../base/eventService/eventApiService";
import store from "../../../context/store/store";
import { URInput } from "../../../shared/widgets/input";
import { Tooltip } from 'antd';
import { initiateCall, sendDirectVideoCallRequest } from "../../../base/callService/callService";
import { ChatService } from "../../../base/chatService";
import singleIcon from "../../../styles/images/Welaunch_Profile_Pic.svg";
import { Types } from "../../../context/action/action";
// import type { MenuProps } from 'antd';

type memberListState = {
  contactList: Array<any>,
  searchMemberList: Array<any>,
  addedMember: Array<any>,
  isModalVisible: boolean,
  isremoveModal: boolean,
  removeMemberDetails: any,
  memberListArray: Array<any>,
  teamMemberList: Array<any>,
  tempMemberlist?:any;

}
// const items = [
//   {
//     label: <a href="https://www.antgroup.com">1st menu item</a>,
//     key: '0',
//   },
//   {
//     label: <a href="https://www.aliyun.com">2nd menu item</a>,
//     key: '1',
//   },
//   {
//     type: 'divider',
//   },
//   {
//     label: '3rd menu item',
//     key: '3',
//   },
// ];

export default function MemberLists() {
  

  const allReducer: initialStateModel = useSelector((state: initialStateModel) => state);
  const history = useHistory();

  let { contactReducer, loginReducer } = allReducer;
  const chatDetails: chatwindowDetails = useSelector((state: initialStateModel) => state.chatWindowReducer);

  const contactList: contacts = contactReducer;
  let { userdetails }: LoginState = loginReducer

  const socketChat = new SocketChatService(userInfo().fromID, userInfo().domainId);

  let adminValue = chatDetails?.chatWindowDetails?.admin_members ? chatDetails?.chatWindowDetails?.admin_members.split(",") : [];
  adminValue = adminValue.map((contactdata: any) => (contactdata.trim()));

  const [memberActions, setMemberActios] = useState<memberListState>({
    contactList: [],
    searchMemberList: [],
    addedMember: [], tempMemberlist: chatDetails?.chatWindowDetails?.teammembersdetails ||chatDetails?.chatWindowDetails?.teammembersdetails,
    isModalVisible: false, isremoveModal: false, removeMemberDetails: {}, memberListArray: [],teamMemberList:[]
  });
  const showModal = () => {
    // setIsModalVisible(true);
    setMemberActios({ ...memberActions, isModalVisible: true });

  };

  /*   const handleOk = () => {
     // setIsModalVisible(false);
     setMemberActios({...memberActions, isModalVisible:false});
    }; */

  const addMembersToTeam = async () => {

    let addmemberdetails = {
      companyId: userdetails.company_id,
      teamId: chatDetails?.chatWindowDetails?.team_id,
      teamMemberFromId: adminValue.includes(userdetails.sip_login_id) ? userdetails.sip_login_id : '',
      teamMemberSipId: memberActions?.addedMember.join()
    };
    socketChat.addTeamMember(addmemberdetails);
    setMemberActios({ ...memberActions, isModalVisible: false,addedMember:[] });
    let { workContactsnew }: contacts = store.getState().contactReducer;
    var name: any =addmemberdetails.teamMemberSipId.toString().split(",");
     var MentionNamedetails: any =[];
     Array.isArray(name) && name.length>0 && 
     name.forEach((el: any) => {
       MentionNamedetails.push(workContactsnew[el]?.caller_id);
     });
    //toastInformation('You Added ' +MentionNamedetails, "success");
    let checkMemCount = MentionNamedetails?.length===1? 'member':'members'
    toastInformation(MentionNamedetails?.length+' '+checkMemCount+" added successfully");
  };
  let teamMemberOnly = chatDetails?.chatWindowDetails?.team_members ? chatDetails?.chatWindowDetails?.team_members.split(",").map((ele: any) => ele.trim()) : [];

  const roleChange = async (member: any, roleChangeInfo: any) => {
    let groupAdmin= chatDetails?.chatWindowDetails.admin_members.split(",");
    groupAdmin=groupAdmin.map((data:any)=> data.trim());
    if(roleChangeInfo ===0 && groupAdmin.length === 1 && groupAdmin.includes(userdetails.sip_login_id) ) {
      toastInformation('change to some Member as Admin', "failure");
      return ;
    }
    let roleInfo = {
      companyId: chatDetails?.chatWindowDetails?.company_id,
      teamId: chatDetails?.chatWindowDetails?.team_id,
      roleType: roleChangeInfo,
      sipId: member.sip_login_id
    }


    const socketChat = new SocketChatService(userInfo().fromID, userInfo().domainId);
    socketChat.membersRoleChange(roleInfo);
    roleChangeInfo === 1 ? toastInformation(member?.caller_id+" is now a group admin", "success") :
    toastInformation(member?.caller_id+" is no longer a group admin", "success");
  };


  const removeFromTeam = async (member: any) => {

    let groupRemoveMembersInfo = {
      companyId: userdetails.company_id,
      teamId: chatDetails?.chatWindowDetails?.team_id,
      teamMemberFromId: adminValue.includes(userdetails.sip_login_id) ? userdetails.sip_login_id : '',
      removeMembersSipId: member.sip_login_id.toString()
    };

    socketChat.removeTeamMember(groupRemoveMembersInfo);
    setMemberActios({ ...memberActions, isremoveModal: false, removeMemberDetails: {} });

    let { workContactsnew }: contacts = store.getState().contactReducer;
    var name: any =groupRemoveMembersInfo.removeMembersSipId.toString().split(",");
     var MentionNamedetails: any =[];
     Array.isArray(name) && name.length>0 && 
     name.forEach((el: any) => {
       MentionNamedetails.push(workContactsnew[el]?.caller_id);
     });
    toastInformation(MentionNamedetails+' has been removed', "success");
  };




  const openRemoveMemberpopup = async (member: any) => {

    setMemberActios({ ...memberActions, isremoveModal: true, removeMemberDetails: member });

  };

  const closeRemoveMemberpopup = async () => {
    setMemberActios({ ...memberActions, isremoveModal: false, removeMemberDetails: {} });

  };

  const handleCancel = () => {
    //setIsModalVisible(false);
    setMemberActios({ ...memberActions, isModalVisible: false ,addedMember:[]});
  };


  const onChangeaddMembers = (values: any) => {

    setMemberActios({ ...memberActions, searchMemberList: memberActions?.contactList, addedMember: values });

  };

  const onSearchMembers = (value: any) => {

    let response = SearchAddMemberTeam(memberActions?.contactList, value.toLowerCase());
    setMemberActios({ ...memberActions, searchMemberList: response });
  };



  // const uniqueTeamMember = Array.from(new Set(memberActions.memberListArray.map((a:any) => a.sip_login_id)))
  //   .map(sip_login_id => {
  //     return memberActions.memberListArray.find((a:any) => a.sip_login_id === sip_login_id);
  //   });
const openChatWindowRight = (input:any) => {
  const userDetails = userInfo();
  const socketChat = new SocketChatService(userDetails.fromID, userDetails.domainId);
  let chatDetail ={chatId:generateChatID(userInfo().fromID, input?.sip_login_id?.toString())};
  
  if(input?.sip_login_id !== loginReducer?.userdetails?.sip_login_id){
    socketChat.openChatWindow(input,history,chatDetail);
}

if(input?.sip_login_id === loginReducer?.userdetails?.sip_login_id)
{
console.log("myspace=====");

  if(window.location.pathname!=="/chats"){
    history.push('/chats');
  }
  
  let mySpaceDetials:any =userdetails;
  mySpaceDetials.isMySpace = true;
  mySpaceDetials.jid = `${mySpaceDetials.sip_login_id}@${mySpaceDetials.host_address}`;
  Service.openChatWindow(mySpaceDetials);
  // const socketChat = new SocketChatService(userInfo().fromID, userInfo().domainId);
  socketChat.getChatHistory(`chat${userInfo().fromID}${userInfo().fromID}${userInfo().domainId}`,"")
  Service.emptyOnMyspace();
  Service.editDraft("");
  chatSideWindow(false,"",{});
  store.dispatch({
    type: Types.TAB_CHANGE,
    payload: {
      ActiveTab: "1"
    }
  });

}
}
  useEffect(() => {
  
        
    if (chatDetails?.chatWindowDetails?.teammembersdetails) {

      let memberList = chatDetails?.chatWindowDetails?.team_members?.split(",");
      memberList = memberList.map((data: any, index: any) => data.trim());

      let list = chatDetails?.chatWindowDetails.teammembersdetails;
     
      let filterdList: any = Object.values(contactList?.workContactsnew);

  filterdList = _.filter(filterdList, function (o: any) { return !memberList.includes(o.sip_login_id.toString()); });

 let sortedList = filterdList.sort(compareName);
    if(list.includes(loginReducer.userdetails)){
      list =  list.filter((item:any) => item.sip_login_id !== loginReducer.userdetails.sip_login_id);
     list.unshift(loginReducer.userdetails);
    }
      setMemberActios({ ...memberActions, memberListArray: list, teamMemberList: list,  contactList: sortedList,
        searchMemberList: sortedList});
    }
    
    showless();
  }, [chatDetails?.chatWindowDetails?.teammembersdetails?.length]);
  let len = Math.ceil((memberActions?.contactList?.length / 8));
  let random_color = Array(len).fill([1, 2, 3, 4, 5, 6, 7, 8]).flat();

  /*raja start */
  type memState ={
    memval:any;
    showless:boolean;
  }

  const [memList, setMemList] = useState<memState>({memval:[],
    showless:false});

  const onclickExpand =()=>{
    var result = _.orderBy(chatDetails?.chatWindowDetails?.teammembersdetails , [(elem:any) => chatDetails?.chatWindowDetails?.admin_members?.includes(elem?.sip_login_id)], ['desc']);
   setMemList({memval:result,showless:true});
  };  

  const showEditMember = (memdata: any) => {
    chatSideWindow(true, "", memdata);
  };

const clickToMeet = (data:any) => {
if(data?.ext) { 
sendDirectVideoCallRequest(data);  
}
else { toastInformation("Future Implementation","failure"); }
}

  const makeAudioCall = (list:any) => {
    if (list.ext) { initiateCall(list.ext, 'audio'); }
    else { toastInformation("Please check the number", "failure"); }
  };
  const OpenChatWindow = (contact: any) => {
    // const userDetails = loginDetails.userdetails;
    const socketservice = new SocketChatService(userdetails.sip_login_id, userdetails.domain_id);
    // socketservice.CreateChat(contact.sip_login_id);
    //  ChatService.openChatWindow(contact, history);
    socketservice.openChatWindow(contact, history);
    ChatService.editDraft("");
    ChatService.saveChatHighlight(false, {});
    ChatService.filesHighlight(false, {});
  };

  const showless =()=>{
    const memberListVal = _.orderBy(chatDetails?.chatWindowDetails?.teammembersdetails, [(elem:any) => chatDetails?.chatWindowDetails?.admin_members?.includes(elem?.sip_login_id)], ['desc']);

    setMemList({memval: memberListVal?.slice(0, 3),showless:false});
  };
  const searchMember =(e:any)=>{
    let input: any = e.target.value.toLowerCase();
    const filterParticipant:any = memberActions.teamMemberList.filter((value: any) => value?.caller_id?.toLowerCase().includes(input) || value?.ext?.toString().includes(input) || value?.team_name?.toLowerCase().includes(input));
    setMemList({memval: filterParticipant,showless:true});
   
  }
  var len1 = Array.isArray(memList.memval)&& memList.memval?.length >7 ?Math.ceil((memList.memval?.length / 6)):1;
  // console.log(len,"len>>>>>>>>>>>>>");
   var random_color1 = Array(len1).fill([1, 2, 3, 4, 5, 6]).flat();
  /*raja end*/
 
  return (

    <>
      <div className={`${styles.memberlists} ${styles.membersidead}`}>
        <div className={styles.titles}>
          <span className={styles.memTitle}>Member</span>
          <span className={styles.memCount}>({(memberActions.teamMemberList.length)})</span>
          <div className={styles.searchBox}>
            <URInput placeHolder="" className="rightbarsearch searchIconRight" onChange={searchMember} />
          </div>
          {/* {adminValue?.includes(userdetails?.sip_login_id) &&  teamMemberOnly.includes(loginReducer.userdetails.sip_login_id.toString().trim()) &&
            <URButton className="rightmemberadd" name="+Add" onClick={showModal} />} */}
        </div>
        {adminValue?.includes(userdetails?.sip_login_id) &&  teamMemberOnly.includes(loginReducer.userdetails.sip_login_id.toString().trim()) &&
        <div className={styles.addParticipant} onClick={showModal}>
            <span className={`icon_plus ${styles.plus}`}></span>
            <span className={styles.participantText} >Add Participants</span>
          </div>
        }
        {/* {memberActions.teamMemberList.length >= 10 && <div className={styles.searchbars}>
          <URInput placeHolder="Search" className="leftbarsearch" onChange={memberSearch} />
        </div>} */}
        <div className={styles.memberscroll}>

          {memList.memval && memList.memval.length > 0 ? memList.memval?.map((member: any, i: any) => (
            <Fragment key={i}>
              {/* <p onClick={() => showEditTask(taskdata)}>
              <URCheckBox className={styles.checkbox}/>{taskdata.summary}</p> */}
              <div className={`fadeIn ${styles.userslists}`} onClick={() => showEditMember(member)}>
                <URAvatarGroup className={`${'lefts size20 memListChat'} colorBG${random_color1[i]} ${styles.avatarset}`}
                    profileInfo={<>{
                      member?.is_blocked === 1 ? <img src={singleIcon} alt="" />:
                      member?.ImageURL || member?.profile_url?
                      <img src={member?.sip_login_id === loginReducer?.userdetails?.sip_login_id?
                      member?.profile_url :member?.ImageURL} alt="" /> : <span>
                        {member?.first_name && (member?.first_name).charAt(0).toUpperCase()+ (member?.last_name).charAt(0).toUpperCase()}</span>}


                      {/* <URStatusDot className={userStatusColor(member?.user_status, 'small')} /> */}
                      </>} />
                     { member?.sip_login_id === loginReducer?.userdetails?.sip_login_id ?
                     <div className={styles.name} >
                    <span>
                      {member?.sip_login_id === loginReducer?.userdetails?.sip_login_id && "You"}
                    </span>
                    { chatDetails?.chatWindowDetails?.admin_members?.includes(member?.sip_login_id)? (<b>Admin</b>) : null}
                    </div>:
                    <div className={styles.name} onClick={()=>openChatWindowRight(member)}>
                    <span>
                      {member?.sip_login_id !== loginReducer?.userdetails?.sip_login_id && member?.caller_id}
                    </span>
                    { chatDetails?.chatWindowDetails?.admin_members?.includes(member?.sip_login_id)? (<b>Admin</b>) : null}
                    </div>}
                  <div className={styles.counts}>{member?.ext}

              
                  </div>
                 
                  <div className={styles.hovericonmore}>
                      <div>
                        <ul>
                          
                          <li><Tooltip placement="top" title="Chat">
                        <span className={`${styles.iconChat} ${member?.is_blocked === 1 && 'blockdisabled'}` } onClick={() => openChatWindowRight(member)}></span>
                          </Tooltip></li>
                          {member?.sip_login_id !== loginReducer?.userdetails?.sip_login_id &&  <li> <Tooltip placement="top" title="Call">
                            <span className={`${styles.iconMeet} iconraidus  `}  onClick={()=>clickToMeet(member)}></span>
                            </Tooltip></li>  }
                          {member?.sip_login_id !== loginReducer?.userdetails?.sip_login_id && <li><Tooltip placement="top" title="Call">
                        <span className={`${styles.iconCall} ${member?.is_blocked === 1 && 'blockdisabled'}` } onClick={() => makeAudioCall(member)}
                        ></span></Tooltip></li>  }
                      
                          <li >
                          {member?.is_blocked !== 1 && member.sip_login_id!==loginReducer.userdetails.sip_login_id.toString().trim()&&
                   teamMemberOnly.includes(loginReducer.userdetails.sip_login_id.toString().trim()) 
                   && adminValue?.includes(userdetails?.sip_login_id.toString()) &&  
                      <Dropdown trigger={['click']}overlay={ <Menu>
                     {adminValue?.includes(member?.sip_login_id.toString()) ?
                       (<Menu.Item onClick={() => roleChange(member, 0)}>
                         Remove Admin Status</Menu.Item>) :
                       (adminValue?.includes(member?.sip_login_id.toString()) ? null :
                         <Menu.Item onClick={() => roleChange(member, 1)}> Make Admin</Menu.Item>)
                     }
                   {  adminValue?.includes(member?.sip_login_id.toString()) ? null :
                   <Menu.Item onClick={()=>openRemoveMemberpopup(member)}>Remove</Menu.Item>}
                      </Menu>}
                      placement="bottomRight">
                        <span className="icon_overflow-H"></span>
                      </Dropdown>}
                  
                          </li>
                        </ul>
                      </div>
                  </div>
              </div>
            </Fragment>
          )): null}
           {memList.showless&& <span className={styles.showLess} onClick={showless}>Show less</span>}
          {!memList.showless &&chatDetails?.chatWindowDetails?.teammembersdetails?.length >3
          && <span onClick={onclickExpand} className={`icon_overflow ${styles.moreOptionMenu}`}></span>}
   
          {/* {memberActions.memberListArray &&
            memberActions.memberListArray.map((member: any, i: any) => (
              <>

                <Fragment key={i}><div className={styles.userslists}>
                  <URAvatarGroup className={`${'lefts size16'} ${styles.avatarset}`}
                    profileInfo={<>{member?.ImageURL || member?.profile_url?
                      <img src={member?.sip_login_id === loginReducer?.userdetails?.sip_login_id?
                      member?.profile_url :member?.ImageURL} alt="" /> : <span>
                        {member?.caller_id && (member?.caller_id).charAt(0)}</span>}


                      <URStatusDot className={userStatusColor(member?.user_status, 'small')} /></>} />
                     { member?.sip_login_id === loginReducer?.userdetails?.sip_login_id ?
                     <div className={styles.name} >
                    <span>
                      {member?.sip_login_id === loginReducer?.userdetails?.sip_login_id && "You"}
                    </span>
                    { chatDetails?.chatWindowDetails?.admin_members?.includes(member?.sip_login_id)? (<b>Admin</b>) : null}
                    </div>:
                    <div className={styles.name} onClick={()=>openChatWindowRight(member)}>
                    <span>
                      {member?.sip_login_id !== loginReducer?.userdetails?.sip_login_id && member?.caller_id}
                    </span>
                    { chatDetails?.chatWindowDetails?.admin_members?.includes(member?.sip_login_id)? (<b>Admin</b>) : null}
                    </div>}
                  <div className={styles.counts}>{member?.ext}

                  {member.sip_login_id!==loginReducer.userdetails.sip_login_id.toString().trim()&&
                   teamMemberOnly.includes(loginReducer.userdetails.sip_login_id.toString().trim()) 
                   && adminValue?.includes(userdetails?.sip_login_id.toString()) &&  
                      <Dropdown overlay={ <Menu>
                     {adminValue?.includes(member?.sip_login_id.toString()) ?
                       (<Menu.Item onClick={() => roleChange(member, 0)}>
                         Remove Admin Status</Menu.Item>) :
                       (adminValue?.includes(member?.sip_login_id.toString()) ? null :
                         <Menu.Item onClick={() => roleChange(member, 1)}> Make Admin</Menu.Item>)
                     }
                   {  adminValue?.includes(member?.sip_login_id.toString()) ? null :
                   <Menu.Item onClick={()=>openRemoveMemberpopup(member)}>Remove</Menu.Item>}
                      </Menu>}
                      placement="bottomRight">
                        <span className="icon_overflow-H"></span>
                      </Dropdown>}
                  </div>
                </div>
                </Fragment>
              </>
            ))} */}
          {/*
          <div className={styles.userslists}>
            <URAvatarGroup className='lefts size16' profileInfo={<><span>D</span>
              <URStatusDot className='stsDotsm green' /></>} />
            <div className={styles.name}><span>Julie Andrews</span><b>Admin</b></div>
            <div className={styles.counts}>
              345
              <Dropdown overlay={menu} placement="bottomRight"><span className="icon_overflow-H"></span></Dropdown>
            </div>
          </div>
         */}
        </div>
      </div>



      <Modal visible={memberActions.isremoveModal} className={`${styles.addmembermodal} ${"modaloverwrite"}`}>
        <span className={`icon_close ${styles.cursorTop}`} onClick={closeRemoveMemberpopup} />
        <h2>Remove Team Member</h2>
        {memberActions.isremoveModal ? (<p>{`  Are you sure, you want to remove ${memberActions?.removeMemberDetails?.caller_id} ? 
         Removed participant will no longer able to send messages to this group`}</p>) : null}
        {/* <p>Are you sure you wish to do this?</p> */}
        <div className={styles.footersection}>
          <URButton className="urButton buttonWhite buttonMd mr8" name="Cancel" onClick={closeRemoveMemberpopup}></URButton>
          <URButton className="urButton buttonRed buttonMd"
            onClick={() => removeFromTeam(memberActions.removeMemberDetails)} name="Remove"></URButton>
        </div>
      </Modal>



      <Modal visible={memberActions.isModalVisible} className={`${styles.addmembermodal} ${"modaloverwrite"}`}
      >
        <span className={`icon_close ${styles.cursorTop}`} onClick={handleCancel} />
        <h2>Add Team Member</h2>
        <p><span className="icon_lock"></span>{ chatDetails?.chatWindowDetails?.team_name.length> 40 ? chatDetails?.chatWindowDetails?.team_name.substring(0,40)+"...": chatDetails?.chatWindowDetails?.team_name}</p>
        {/*         <Select
          mode="multiple"
          style={{ width: '100%' }}
          placeholder="Search for extention or member"
          className="newselects"> */}
        <Select
          mode="multiple"
          style={{ width: '100%' }}
          placeholder="Search a user name or extension number"
          className="newselects"
          dropdownClassName="newChatSel"
          value={memberActions.addedMember}
          onChange={(e: any) => onChangeaddMembers(e)} onSearch={onSearchMembers} showSearch={true}
         /*  optionLabelProp = "label"  */ filterOption={false}>

          {memberActions?.searchMemberList.map((contact: any, index: number) => {

            return (<option value={contact.sip_login_id} key={index}>
              <div className="dropdowndesign">
                {/* <div className="usergroups">
                  {contact.ImageURL ?
                    <img src={contact.ImageURL && contact.ImageURL} /> :
                    <span>{contact?.caller_id?.charAt(0)}</span>
                  }
                  <URStatusDot className={userStatusColor(contact?.user_status, 'small')} />
                </div>
                <div className="names">{contact.caller_id}</div>
                <div className="ext">{contact.ext}</div> */}

                <div className="usergroupss">
                  <URAvatarGroup className={`lefts size20 colorBG${random_color[index]}`} profileInfo={<>
                    {contact.ImageURL ?
                      <img src={contact.ImageURL} alt="" /> :
                      <span>{contact.first_name?.charAt(0)+contact.last_name?.charAt(0)}</span>}
                    <URStatusDot
                      className={userStatusColor(contact?.user_status,'small')}/>
                  </> } />
                </div>
                <div className="names">{contact.caller_id}</div>
                <div className="ext">{contact.ext}</div>
              </div>
            </option>);
          })}


        </Select>
        <div className={styles.footersection}>
          <URButton className='urButton buttonWhite buttonMd mr8' name="Cancel" onClick={handleCancel}></URButton>
          <URButton className='urButton buttonBlue buttonMd' onClick={addMembersToTeam}  disabled={memberActions.addedMember.length===0 && memberActions.addedMember.length===0?true:false}name="Add"></URButton>
        </div>
      </Modal>


    </>
  );
};

